
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { OperationalComponent } from './operational.component';
import { ClientModule } from './client/client.module';
import { ConsortiumModule } from './consortium/consortium.module';
import { RoleMasterModule } from './role/role.module';
import { CountryMasterModule } from './country/country.module';
import { VesselModule } from './vessel/vessel.module';
import { ContainerModule } from './container/container.module';
import { EquipmentModule } from './equipment/equipment.module';
import { EquipmentSizeModule } from './equipment-size/equipment-size.module';
import { PackageModule } from './package/package.module';
import { CommodityModule } from './commodity/commodity.module';
import { LinerServiceModule } from './liner-service/liner-service.module';
import { LinerOriginServiceModule } from './liner-origin-service/liner-origin-service.module';
import { VesselVoyageModule } from './vessel-voyage/vessel-voyage.module';
import { UnitModule } from './unit/unit.module';
import { CustomerServiceRequirementModule } from './customer-service-requirement/customer-service-requirement.module';
import { CountryWiseServiceRequirementModule } from './country-wise-service-requirement/country-wise-service-requirement.module';
import { WeeklyConsolPlanningModule } from './weekly-consol-planning/weekly-consol-planning.module';
import { ShareWeeklyConsolPlanningModule } from './share-weekly-consol-planning/share-weekly-consol-planning.module';
import { ServiceModule } from './service/service.module';
import { ContainerMarginModule } from './container-margin/container-margin.module';

export const baseRoutes: Routes = [
  {
    path: '',
    data: {
      title: 'Operational',
    },
    children: [
      {
        path: 'consortium',
        loadChildren:() => ConsortiumModule
      },
      {
        path: 'client',
        loadChildren:() => ClientModule
      },
      {
        path: 'role',
        loadChildren:() => RoleMasterModule
      },
      {
        path: 'country',
        loadChildren:() => CountryMasterModule
      },
      {
        path: 'vessel',
        loadChildren:() => VesselModule
      },
      {  path: 'container',
        loadChildren:() => ContainerModule
      },
      {
        path: 'equipment',
        loadChildren:() => EquipmentModule
      },
      {
        path: 'equipment-size',
        loadChildren:() => EquipmentSizeModule
      },
      {
        path: 'package',
        loadChildren:() => PackageModule
      },
      {
        path: 'commodity',
        loadChildren:() => CommodityModule
      },
      {
        path: 'liner-service',
        loadChildren:() => LinerServiceModule
      },
      {
        path: 'liner-origin-service',
        loadChildren:() => LinerOriginServiceModule
      },
      {
        path: 'commodity',
        loadChildren:() => CommodityModule
      },
      {
        path: 'vessel-voyage',
        loadChildren:() => VesselVoyageModule
      },
      {
        path: 'unit',
        loadChildren:() => UnitModule
      },
      {
        path: 'customer-service-requirement',
        loadChildren:() => CustomerServiceRequirementModule
      },
      {
        path: 'country-wise-service-requirement',
        loadChildren:() => CountryWiseServiceRequirementModule
      },
      {
        path: 'weekly-consol-planning',
        loadChildren:() => WeeklyConsolPlanningModule
      },
      {
        path: 'share-weekly-consol-planning',
        loadChildren:() => ShareWeeklyConsolPlanningModule
      },
      {
        path: 'service',
        loadChildren: () => ServiceModule
      },
      {
        path: 'container-margin',
        loadChildren: () => ContainerMarginModule
      },
    ]
  }

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(baseRoutes)
  ],
  declarations: [OperationalComponent]
})
export class OperationalModule { }
